export default __webpack_public_path__ + "static/media/ash-icon.6dca1ce5.svg";